type Params = {
  min: number | null;
  max: number | null;
  prefix: string;
};
/**
 * Computes message to display for a bio exam field given two ref values
 * @param params {Object}: min, max ref values of bio exam result field, and custom prefix
 */
function getReferenceValuesMessage({ min, max, prefix }: Params) {
  if (min == undefined && max == undefined) return "";
  let values: string;
  if (min != undefined && max != undefined) {
    values = "entre " + min + " et " + max;
  } else {
    if (min != undefined) values = "> " + min;
    else values = "< " + max;
  }
  return prefix + values;
}

export default getReferenceValuesMessage;
